import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ListChecks, Timer, BarChart3, Sparkles, ArrowRight } from 'lucide-react';
import { Button } from '../shared/Button';

export const HowItWorks: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const steps = [
    {
      icon: ListChecks,
      number: '01',
      titleKey: 'landing.howItWorks.step1.title',
      descriptionKey: 'landing.howItWorks.step1.description',
    },
    {
      icon: Timer,
      number: '02',
      titleKey: 'landing.howItWorks.step2.title',
      descriptionKey: 'landing.howItWorks.step2.description',
    },
    {
      icon: BarChart3,
      number: '03',
      titleKey: 'landing.howItWorks.step3.title',
      descriptionKey: 'landing.howItWorks.step3.description',
    },
  ];

  return (
    <section id="how-it-works" className="section-shell">
      <div className="section-container">
        <div className="mx-auto text-center">
          <span className="section-eyebrow">
            {t('landing.howItWorks.eyebrow')}
          </span>
          <h2 className="section-title mx-auto">
            {t('landing.howItWorks.title').split(t('landing.howItWorks.titleHighlight'))[0]}
            <span className="text-primary">{t('landing.howItWorks.titleHighlight')}</span>
          </h2>
          <p className="section-subtitle mx-auto">
            {t('landing.howItWorks.subtitle')}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <article key={index} className="surface-card-soft p-6">
                <div className="mb-4 flex items-center justify-between">
                  <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10">
                    <Icon className="h-5 w-5 text-primary" />
                  </div>
                  <span className="text-sm font-bold text-primary/40">{step.number}</span>
                </div>
                <h3 className="text-xl font-semibold text-ink">{t(step.titleKey)}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">
                  {t(step.descriptionKey)}
                </p>
              </article>
            );
          })}
        </div>

        <div className="mt-10 rounded-3xl border border-primary/10 bg-primary/5 p-8 text-center">
          <div className="mx-auto mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10">
            <Sparkles className="h-5 w-5 text-primary" />
          </div>
          <h3 className="text-xl font-semibold text-ink">
            {t('landing.howItWorks.differentiator.title')}
          </h3>
          <p className="mx-auto mt-2 max-w-3xl text-sm leading-relaxed text-slate-600">
            {t('landing.howItWorks.differentiator.description')}
          </p>
        </div>

        <div className="mt-10 text-center">
          <Button
            variant="primary"
            size="large"
            icon={<ArrowRight className="h-5 w-5" />}
            onClick={() => navigate('/try-free')}
          >
            {t('landing.howItWorks.cta')}
          </Button>
          <p className="mt-4 text-sm text-slate-500">
            {t('landing.howItWorks.noCreditCard')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
